module.exports = require("@fortawesome/pro-solid-svg-icons/faArrowRight");